import React, { useContext, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faEnvelope, faUnlockAlt, faUser } from "@fortawesome/free-solid-svg-icons";
import {
	Col,
	Row,
	Form,
	Card,
	Button,
	FormCheck,
	Container,
	InputGroup,
} from "@themesberg/react-bootstrap";
import { Link, useNavigate } from "react-router-dom";

import { routesPath } from "../../routes";
import { AuthContext } from "src/app/contexts/AuthContext";
import { AUTH_REDUCER_SET_AUTH_DATA } from "src/app/common/constants";

const ROOT = "https://jorooms.com";

export default () => {
	const [username, setUsername] = useState("");
	const [password, setPassword] = useState("");
	const [rememberMe, setRememberMe] = useState(false);
	const { authData, dispatch } = useContext(AuthContext);

	const locationHistory = useNavigate();

	const handleOnSubmit = (e) => {
		e.preventDefault();
		dispatch({ type: AUTH_REDUCER_SET_AUTH_DATA, payload: { username, password, rememberMe } });
		locationHistory(routesPath.Home.path);
	};

	return (
		<main>
			<section className="d-flex align-items-center my-5 mt-lg-6 mb-lg-5">
				<Container>
					<p className="text-center">
						<Card.Link href={ROOT} className="text-gray-700">
							<FontAwesomeIcon icon={faAngleLeft} className="me-2" /> Back to homepage
						</Card.Link>
					</p>
					<Row
						className="justify-content-center form-bg-image"
						/* style={{ backgroundImage: `url(${BgImage})` }} */
					>
						<Col xs={12} className="d-flex align-items-center justify-content-center">
							<div className="bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100 fmxw-500">
								<div className="text-center text-md-center mb-4 mt-md-0">
									<h3 className="mb-0">Sign in to our platform</h3>
								</div>
								<Form className="mt-4" onSubmit={(e) => handleOnSubmit(e)}>
									<Form.Group id="email" className="mb-4">
										<Form.Label>Email</Form.Label>
										<InputGroup>
											<InputGroup.Text>
												<FontAwesomeIcon icon={faUser} />
											</InputGroup.Text>
											<Form.Control
												autoFocus
												required
												type="text"
												placeholder="john@doe.com"
												value={username}
												onChange={(e) => setUsername(e.target.value)}
											/>
										</InputGroup>
									</Form.Group>
									<Form.Group>
										<Form.Group id="password" className="mb-4">
											<Form.Label>Your Password</Form.Label>
											<InputGroup>
												<InputGroup.Text>
													<FontAwesomeIcon icon={faUnlockAlt} />
												</InputGroup.Text>
												<Form.Control
													required
													type="password"
													placeholder="Password"
													value={password}
													onChange={(e) => setPassword(e.target.value)}
												/>
											</InputGroup>
										</Form.Group>
										<div className="d-flex justify-content-between align-items-center mb-4">
											<Form.Check type="checkbox">
												<FormCheck.Input
													id="defaultCheck5"
													className="me-2"
													checked={rememberMe}
													onChange={(e) =>
														setRememberMe(e.target.checked)
													}
												/>
												<FormCheck.Label
													htmlFor="defaultCheck5"
													className="mb-0"
												>
													Remember me
												</FormCheck.Label>
											</Form.Check>
											{/* <Card.Link className="small text-end">
												Lost password?
											</Card.Link> */}
										</div>
									</Form.Group>
									<Button variant="primary" type="submit" className="w-100">
										Sign in
									</Button>
								</Form>

								<div class="flex items-center justify-end mt-4">
									<a class="underline text-sm text-gray-600 hover:text-gray-900"
									href="/register">Create account</a><br />

									<a class="underline text-sm text-gray-600 hover:text-gray-900"
										href="/forgot-password">Forgot your password?</a>
                            	</div>
							</div>
						</Col>
					</Row>
				</Container>
			</section>
		</main>
	);
};
